import React, { useState } from "react";
import { Form, FormInstance, DatePicker, DatePickerProps, Col } from "antd";
import styles from "../MemberProfile.module.scss";
import textStyles from "../../../Shared/Styles/TextStyles.module.scss";
import { MomentInput } from "moment";
import moment from "moment";

type Props = {
  form: FormInstance;
};

const ProfileDateOfBirth: React.FC<Props> = ({ form }) => {
  const [displayError, setDisplayError] = useState<boolean>(false);

  const isValidDob = (dateOfBirth: MomentInput) =>
    dateOfBirth && moment().diff(dateOfBirth, "years") > 18;

  const handleDateChange: DatePickerProps["onChange"] = (date) => {
    const isAgeOver18 = form.getFieldValue("isAgeOver18");
    if (date && isValidDob(date)) {
      form.setFieldsValue({ dateOfBirth: date });
      setDisplayError(isAgeOver18 === "N");
    } else {
      form.setFieldsValue({ dateOfBirth: null });
      setDisplayError(isAgeOver18 === "N" || date !== null);
    }
  };

  const handleDateBlur: DatePickerProps["onBlur"] = (e: any) => {
    const dateOfBirth = e.target.value;

    if (dateOfBirth && !isValidDob(moment(dateOfBirth))) {
      setDisplayError(true);
      form.setFieldsValue({
        dateOfBirth: null,
      });
    }
  };

  const getPickerClassName = () => {
    const dateOfBirth = form.getFieldValue("dateOfBirth");

    if (dateOfBirth !== undefined) {
      return !isValidDob(dateOfBirth) ? `${styles.errorBorder}` : "";
    }
  };

  return (
    <>
      <Form.Item
        name="dateOfBirth"
        label="Date of birth"
        className={`${styles.datePickerFormItem} ${displayError &&
          styles.marginDown0} `}
      >
        <DatePicker
          className={getPickerClassName()}
          value={form.getFieldValue("dateOfBirth")}
          format="MM/DD/YYYY"
          placeholder="Select date"
          onChange={handleDateChange}
          onBlur={(e) => handleDateBlur(e)}
        />
      </Form.Item>

      {displayError && (
        <Col
          span={24}
          className={`${textStyles.errorNormalText14} ${styles.marginDown16}`}
        >
          Service users must be at least 18 years old.
        </Col>
      )}
    </>
  );
};

export default ProfileDateOfBirth;
